import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiSettings, FiLock } from 'react-icons/fi';
import { useSettings } from '../settings/shared';
import { translate } from '../password/model';
import PageLayout from '../../components/layout/PageLayout';
import './Auth.css';
export default function GuestMyPage() {
  const { style, locale } = useSettings(),
    location = useLocation(),
    t = (k) => translate(locale, k);
  return (
    <PageLayout paddingTop={0} paddingBottom={0}>
      <div className="pp-settings pp-guest-my" style={style}>
        <div className="pp-guest-actions">
          <Link to="/mypage/settings" aria-label={locale === 'en' ? 'Settings' : '설정'}>
            <FiSettings size={21} />
          </Link>
        </div>
        <section className="pp-guest-state">
          <FiLock size={28} strokeWidth={1.5} aria-hidden="true" />
          <h1>{t('common.loginRequired')}</h1>
          <p>{t('common.loginRequiredBody')}</p>
          <Link
            to={'/login?redirectUrl=' + encodeURIComponent(location.pathname + location.search)}
          >
            {t('common.login')}
          </Link>
        </section>
      </div>
    </PageLayout>
  );
}
